import { useTransferData } from '@/shared/hooks/useTransferData';
import { providerCompanyService } from '@/services/providerCompany.service';
import { ProviderCompany } from '@/services/types/user.types';

export function useProvidersTransfer() {
  const { items: providers } = useTransferData<ProviderCompany>({
    fetchFn: () => providerCompanyService.getAllProviders(),
    mapper: {
      key: (item) => item.id,
      title: (item) => item.name,
      description: (item) => item.shortName,
      disabled: () => false,
    },
    errorMessage: 'Erro ao buscar dados das Provedoras.',
  });

  return {
    providers,
  };
}
